export let projectDetail = null;

export function setProjectDetail ( data ){
    projectDetail = data;
}